import api from "./axios";

export const transformQuery = (query) => {
  const queryString = Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join("&");
  if (queryString.length === 0) {
    return "";
  } else {
    return `?${queryString}`;
  }
};

export async function getOrders(params, page = 1) {
  let query = "";
  if (params) {
    query = transformQuery(params);
  }
  // Append the page number to the query string
  query += (query ? "&" : "?") + `page=${page}`;
  const response = await api.get(`/orders${query}`);
  return response;
}

export async function getSimplifiedOrders(userId, userRole) {
  const response = await api.get(`/orders/simplifiedOrders/${userId}/${userRole}`);
  return response;
}

export async function getUserAreas(userId) {
  const response = await api.get(`/orders/user-areas/${userId}`);
  return response;
}

export async function getOrder(orderId) {
  const response = await api.get(`/orders/${encodeURIComponent(orderId)}`);
  return response;
}

export async function postOrder(order) {
  const response = await api.post("/orders", order);
  return response;
}

export async function deleteOrder(orderId) {
  const response = await api.delete(`/orders/${encodeURIComponent(orderId)}`);
  return response;
}

export async function putOrder(order, orderId) {
  const response = await api.put(`/orders/${encodeURIComponent(orderId)}`, order);
  return response;
}
